import { listenAndroidKeybord } from './app-compatible.js'
const isAndroid = (function () {
  return !!(window.androidToJs && window.androidToJs.getAppName instanceof Function && window.androidToJs.getAppName() === 'com.xuetangx.ykt')
})()
function goAppLink(link, androidLink) {
  if (isAndroid) {
    // window.toLink(androidLink)
  }
}
function backApp() {
  window.androidToJs && window.androidToJs.closeActivity instanceof Function && window.androidToJs.closeActivity()
}
// 页面分享 
function share(title= '', desc= '', link= '', imgUrl= '') {
  window.androidToJs && window.androidToJs.shareWeixinConfig instanceof Function && window.androidToJs.shareWeixinConfig(title, desc, link, imgUrl)
}
/**
 * Flutter 客户端里的功能设置
 */
const isFlutterApp = (function isFlutterApp() {
  return navigator.userAgent.indexOf('flutterApp') > -1
})()
// Flutter 方法调用
function callFlutter(method, data) {
  if(isFlutterApp){
    let params = {
      code: 0,
      method,
      data,
      msg: 'success'
    }
    if(navigator.userAgent.toLocaleLowerCase().indexOf("iphone") > -1 || navigator.userAgent.toLocaleLowerCase().indexOf("ipad") > -1) {
      try {
        window.webkit.messageHandlers.JsCallFlutter.postMessage(JSON.stringify(params))
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        JsCallFlutter.postMessage(JSON.stringify(params))
      } catch (error) {
        console.log(error)
      }
    }
  }
}
export { isAndroid, goAppLink, backApp, share, isFlutterApp, callFlutter, listenAndroidKeybord}


// WEBPACK FOOTER //
// ./src/util/android.js